import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取格式化课包列表
 * @param {*} params 
 */
export function getFormatCoursePackagesForCourse(param) {
    // let data = qs.stringify(param)
    return request({
        url: '/api/manager/coursepackage/format_coursepackages_forcourse',
        method: 'get',
        params: param
    })
}

/**
 * 获取格式化课包列表
 * @param {*} params 
 */
export function getFormatCoursePackagesByUserName(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/coursepackage/format_coursepackages_byusername',
        method: 'post',
        data: data
    })
}


/**
 * 获取格式化课包列表
 * @param {*} params 
 */
export function getFormatCoursePackages(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackage/format_coursepackages',
        method: 'get',
        params: param
    })
}


/**
 * 获取课程类型列表
 * @param {*} params 
 */
export function getCoursePackages(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackage/coursepackages',
        method: 'get',
        params: param
    })
}

/**
 * 删除指定id的课程类型
 * @param {*} id 
 */
export function deleteCoursePackage(id) {
    return request({
        url: '/api/manager/coursepackage/' + id,
        method: 'delete'
    })
}

/**
 * 添加预约类型
 * @param {}} param 
 */
export function addCoursePackage(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/coursepackage',
        method: 'post',
        data: data
    })
}

/**
 * 修改预约类型
 * @param {}} param 
 */
export function editCoursePackage(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/coursepackage',
        method: 'put',
        data: data
    })
}
//查询课包回收站列表
export function coursepackagesRecycle(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackage/coursepackagesRecycle',
        method: 'get',
        params: param
    })
}
//恢复课包
export function recoverCoursepackage(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackage/recoverCoursepackage',
        method: 'get',
        params: param
    })
}